var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgServices(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_69_1394)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.6136 17.67H19.375V19.6333H0V17.67H1.76136V0.981667C1.76136 0.721312 1.85415 0.471622 2.01931 0.287523C2.18447 0.103425 2.40847 0 2.64205 0H16.733C16.9665 0 17.1905 0.103425 17.3557 0.287523C17.5209 0.471622 17.6136 0.721312 17.6136 0.981667V17.67ZM6.16477 8.835V10.7983H8.80682V8.835H6.16477ZM6.16477 4.90833V6.87167H8.80682V4.90833H6.16477ZM6.16477 12.7617V14.725H8.80682V12.7617H6.16477ZM10.5682 12.7617V14.725H13.2102V12.7617H10.5682ZM10.5682 8.835V10.7983H13.2102V8.835H10.5682ZM10.5682 4.90833V6.87167H13.2102V4.90833H10.5682Z",
    fill: "currentColor"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_69_1394"
  }, /*#__PURE__*/React.createElement("rect", {
    width: "1em",
    height: "1em",
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgServices);
export default __webpack_public_path__ + "static/media/services.7f7630e7ce2e930bd6115cfcd90ef6f4.svg";
export { ForwardRef as ReactComponent };